import helper from "@/form_builder/components/form/ui/helper.js";

const elOption = {
  vue_tag: "select",
  tag: "el-option",
  name: "eloption",
  __openRules: false,
  tagIcon: "input",
  ctrlBtn: true,
  attrs: {
    fieldName: helper.input_text("Nombre de campo", "nombre de campo"),
  },
  slots: {},
  props: {},
  childrens: [],
};

export default {
  tag: "el-select",
  name: "Tipo Lista",
  title:
    "Tipo de campo LISTA que permite elegir una opción de un menú desplegable, facilitando la selección de datos predefinidos.",

  __openRules: false,
  tagIcon: "select",
  ctrlBtn: true,
  defaultvalue: "",

  __opt__: helper.input_opt("Opciones", "el-option"),

  formItem: {
    showLabel: helper.input_boolean("Mostrar etiqueta", true),
    label: helper.input_text("Etiqueta", "Campo"),
  },
  attrs: {
    fieldName: helper.input_text("Nombre de campo", "nombre de campo"),
  },
  slots: {},
  props: {},
  childrens: [],
};
